import { render } from "./tuesday-lunch.vue?vue&type=template&id=5504a1b8"
import script from "./tuesday-lunch.vue?vue&type=script&lang=js"
export * from "./tuesday-lunch.vue?vue&type=script&lang=js"
script.render = render

export default script